import React from 'react'
import _ from 'lodash'
import { setPortal, updatePortal, changePortal } from '../../actions/portal'
import { connect } from 'react-redux'
import { compose } from 'redux'

const isNotEmpty = value => !_.isEmpty(value)

export class AutoRemoteSync extends React.Component {
  constructor(props) {
    super(props)

    this.unsubscribe = props.store.subscribe(this.handleSynchronize)
  }

  handleSynchronize = () => {
    const state = this.props.store.getState()
    const syncVersion = state.info.syncVersion
    if (this.syncVersion !== syncVersion) {
      this.syncVersion = syncVersion
      if (this.syncVersion > 0)
        this.props.store.dispatch(updatePortal(state.portal))
    }
  }

  componentWillUnmount() {
    this.unsubscribe()
  }

  render() {
    return React.Children.map(this.props.children, child =>
      React.cloneElement(child, this.props),
    )
  }
}

const withAutoSyncOnFormEvent = createOptions => WrappedComponent => {
  return class AutoSyncOnFormEvent extends React.Component {
    getPath = suffixField => {
      if (!createOptions) return suffixField
      const prefixPath = createOptions(this.props).path
      return [prefixPath, suffixField].filter(isNotEmpty).join('.')
    }

    updatePortal = newPortal => {
      this.props.updatePortal(newPortal)
    }

    updatePortalAtPath = (path, values) => {
      this.props.changePortal(path, values)
    }

    handleAutoSync = (name, value) => {
      this.props.changePortal(this.getPath(name), value)
    }

    handleAutoSyncOnBlur = e => {
      this.handleAutoSync(e.target.name, e.target.value)
      if (this.props.handleBlur && e.persist) {
        this.props.handleBlur(e)
      }
    }

    handleAutoSyncOnChange = e => {
      // console.log('e.target.value', typeof e.target.value, e.target.value)
      this.handleAutoSync(e.target.name, e.target.value)

      if (this.props.handleChange && e.persist) {
        this.props.handleChange(e)
      }
    }

    render() {
      return (
        <WrappedComponent
          {...this.props}
          handleAutoSync={this.handleAutoSync}
          handleAutoSyncOnBlur={this.handleAutoSyncOnBlur}
          handleAutoSyncOnChange={this.handleAutoSyncOnChange}
          updatePortalAtPath={this.updatePortalAtPath}
        />
      )
    }
  }
}

export const withPortalRemoteUpdater = connect(
  ({ portal, info }) => ({ portal, info }),
  {
    setPortal,
    updatePortal,
    changePortal,
  },
)

export const withPortalAutoRemoteSync = createOptions =>
  compose(withPortalRemoteUpdater, withAutoSyncOnFormEvent(createOptions))

export default withPortalAutoRemoteSync



// WEBPACK FOOTER //
// ./src/modules/common/withPortalAutoRemoteSync.js